import './TotpEdit.css';
import TopBar from "../common/TopBar";
import CommonPopup from "../common/CommonPopup";
import SelectIcon from "./SelectIcon";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TotpEdit({ otpRow, onSave, onCancel, onDelete }) {
  const {mName, mSecret, mIssuer, mAlgorithm, mDigits, mPeriod, mIcon} = otpRow;
  const { t } = useTranslation();

  const [name, setName] = useState(mName || '');
  const [icon, setIcon] = useState(mIcon || '');
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showIconSelect, setShowIconSelect] = useState(false);
  const isChanged = name !== (mName || '') || icon !== (mIcon || '');
  const initials = mIssuer ? mIssuer.substring(0, 2).toUpperCase() : 'AZ';

  const topHeader = {
    title: t('totpEdit.title'),
    leftIcon: "/images/totp/ui/left.png",
    rightIcon: isChanged ? "/images/totp/ui/menu_save_full.png" : "/images/totp/ui/menu_save.png"
  }

  const handleBack = () => {
    onCancel();
  }

  const handleSave = () => {
    const updatedOtpRow = { ...otpRow, mName: name, mIcon: icon };
    onSave(updatedOtpRow);
  }

  const handleInitials = () => {
    setIcon('');
  }
  const handleOpenIconSelect = () => {
    setShowIconSelect(true);
  }

  const handleSelectIcon = (iconPath) => {
    // /images/totp/item-icon/google-play.png
    console.log( "iconPath " , iconPath);
    setIcon(iconPath);
    setShowIconSelect(false);
  }

  const handleCancelIconSelect = () => {
    setShowIconSelect(false);
  }

  const handleDelete = () => {
    setShowDeletePopup(true);
  }

  const handleConfirmDelete = () => {
    setShowDeletePopup(false);
    onDelete(otpRow);
  }

  const handleCancelDelete = () => {
    setShowDeletePopup(false);
  }

  const onChangeName = (newText) => {
    setName(newText);
  }

  return(
    <div className="totp-edit-wrapper">
      <TopBar topHeader={topHeader} onLeftClick={handleBack} onRightClick={handleSave}/>
      <div className="totp-edit-container">

        <div className="edit-rows-wrapper">
          {/* Icon Row */}
          <div className="edit-row edit-icon-row">
            <div className="edit-label">{t('totpEdit.icon')}</div>
            <div className="edit-icons">
              <div className={"edit-icon-box " + (icon ? "" : "selected")} onClick={handleInitials}>{initials}</div>
              <div className={"edit-icon-box " + (icon ? "selected" : "")} onClick={handleOpenIconSelect}>
                {icon ? <img src={`${process.env.PUBLIC_URL}${icon}`} alt="icon" /> : <img src={`${process.env.PUBLIC_URL}/images/totp/ui/lock_unselect.png`} alt="lock" />}
              </div>
            </div>
          </div>

          {/* Name Row */}
          <div className="edit-row">
            <div className="edit-label">{t('totpEdit.name')}</div>
            <input
              type="text"
              className="edit-name-input"
              value={name}
              onChange={(e) => onChangeName(e.target.value) }
            />
          </div>

          {/* Issuer Row */}
          <div className="edit-row">
            <div className="edit-label">{t('totpEdit.issuer')}</div>
            <div className="edit-value">{mIssuer}</div>
          </div>

          {/* Algorithm Row */}
          <div className="edit-row">
            <div className="edit-label">{t('totpEdit.algorithm')}</div>
            <div className="edit-value">{mAlgorithm}</div>
          </div>

          {/* Period Row */}
          <div className="edit-row">
            <div className="edit-label">{t('totpEdit.period')}</div>
            <div className="edit-value">{mPeriod} {t('totpEdit.periodUnit')}</div>
          </div>
        </div>

        {/* Delete Section */}
        <div className="delete-section">
          <p>{t('totpEdit.deleteQuestion')}</p>
          <button className="delete-button" onClick={handleDelete}>{t('totpEdit.deleteButton')}</button>
        </div>

      </div>

      <CommonPopup
        isOpen={showDeletePopup}
        message={t('totpEdit.confirmDelete')}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />

      <SelectIcon
        isOpen={showIconSelect}
        selectedIcon={icon}
        onSelect={handleSelectIcon}
        onCancel={handleCancelIconSelect}
      />
    </div>
  )
}
